export const createFormItemLayout = (labelSpan, wrapperSpan) => ({
  labelCol: { span: labelSpan },
  wrapperCol: { span: wrapperSpan }
})
